import { is } from "bpmn-js/lib/util/ModelUtil";
import { primaryBindingFor } from "modules/fluss/components/node-properties/fluss-node-panel-utils";

export type FlussCallActivityOpenHandler = (binding: any) => void;
export type FlussCanvasTranslator = (key: string, options?: { defaultValue?: string }) => string;

let onOpen: FlussCallActivityOpenHandler | undefined;
let translate: FlussCanvasTranslator = (key, options) => options?.defaultValue ?? key;

export const setFlussCallActivityOpenHandler = (next?: FlussCallActivityOpenHandler) => {
    onOpen = next;
};

export const setFlussCallActivityOverlayTranslate = (next: FlussCanvasTranslator) => {
    translate = next;
};

function FlussCallActivityOverlayBehavior(this: any, eventBus: any, overlays: any, elementRegistry: any) {
    const overlayIds = new Map<string, string>();

    const remove = (elementId: string) => {
        const overlayId = overlayIds.get(elementId);
        if (!overlayId) return;
        overlays.remove(overlayId);
        overlayIds.delete(elementId);
    };

const add = (element: any) => {
    if (!element || !is(element, "bpmn:CallActivity")) {
        if (element?.id) remove(element.id);
        return;
    }
    remove(element.id);

        const button = document.createElement("button");
        button.type = "button";
        button.className = "fluss-call-activity-open";
        button.title = translate("fluss.canvas.open_call_activity_target", { defaultValue: "Open the referenced process in a new tab" });
        button.setAttribute("aria-label", button.title);
        button.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            onOpen?.(primaryBindingFor(element.businessObject));
        });

        const overlayId = overlays.add(element, "fluss-call-activity-open", {
            position: { left: element.width / 2 - 7, bottom: 6 },
            html: button,
        });
        overlayIds.set(element.id, overlayId);
    };

    const refreshAll = () => {
        elementRegistry.filter((element: any) => is(element, "bpmn:CallActivity")).forEach(add);
    };

    eventBus.on("import.render.complete", refreshAll);
    eventBus.on("shape.create", (event: any) => add(event.context?.shape || event.shape));
    eventBus.on("shape.delete", (event: any) => remove((event.context?.shape || event.shape)?.id));
    eventBus.on("element.changed", (event: any) => add(event.element));
}

(FlussCallActivityOverlayBehavior as any).$inject = ["eventBus", "overlays", "elementRegistry"];

export const flussCallActivityOverlayModule = {
    __init__: ["flussCallActivityOverlayBehavior"],
    flussCallActivityOverlayBehavior: ["type", FlussCallActivityOverlayBehavior],
};
